import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { useQueryClient } from '@tanstack/react-query'
import { cancelOnboarding } from '@/api/onboarding'

export function OnboardingResetPage() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [done, setDone] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    cancelOnboarding()
      .then(() => {
        if (cancelled) return
        // Чистим клиентский кеш креативов
        try {
          Object.keys(sessionStorage).forEach((key) => {
            if (
              key.startsWith('tgx-creatives-result-') ||
              key.startsWith('tgx-campaigns-result-')
            ) sessionStorage.removeItem(key)
          })
        } catch {}
        // Сбрасываем выбранный канал в LK — иначе старый канал пинятся в ProjectSelector
        try {
          localStorage.removeItem('tgx-selected-channel-uuid')
        } catch {}
        queryClient.invalidateQueries({ queryKey: ['channels'] })
        setDone(true)
      })
      .catch((e) => {
        if (cancelled) return
        setError(e instanceof Error ? e.message : 'Не удалось сбросить онбординг')
      })
    return () => {
      cancelled = true
    }
  }, [queryClient])

  useEffect(() => {
    if (!done) return
    const t = setTimeout(() => navigate('/onboarding', { replace: true }), 800)
    return () => clearTimeout(t)
  }, [done, navigate])

  return (
    <div className="reset-wrap">
      {error ? (
        <>
          <h1 className="reset-title">Не получилось сбросить</h1>
          <p className="reset-text">{error}</p>
          <button className="reset-btn" onClick={() => navigate('/onboarding')}>
            Пойти на /onboarding всё равно
          </button>
        </>
      ) : (
        <>
          <div className="reset-spinner" />
          <h1 className="reset-title">Сбрасываем онбординг…</h1>
          <p className="reset-text">{done ? 'Готово, перенаправляем…' : 'Чистим состояние сессии.'}</p>
        </>
      )}

      <style>{`
        .reset-wrap {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 14px;
          padding: 32px;
          background: var(--tg-paper, #fafafd);
          font-family: var(--tg-font, Inter, sans-serif);
        }
        .reset-spinner {
          width: 40px;
          height: 40px;
          border: 3px solid var(--tg-line-2, #f0f0f4);
          border-top-color: var(--tg-blue, #0080ff);
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
          margin-bottom: 8px;
        }
        @keyframes spin { to { transform: rotate(360deg); } }
        .reset-title {
          margin: 0;
          font-size: 22px;
          font-weight: 800;
          color: var(--tg-ink, #111);
        }
        .reset-text {
          margin: 0;
          font-size: 14px;
          color: var(--tg-mute, #8f9eb0);
        }
        .reset-btn {
          margin-top: 12px;
          padding: 10px 18px;
          background: var(--tg-blue, #0080ff);
          color: white;
          border: 0;
          border-radius: 10px;
          font-family: inherit;
          font-weight: 700;
          cursor: pointer;
        }
      `}</style>
    </div>
  )
}
